import { Avatar, Image, Button, message } from "antd";
import iconImage from "../../../assets/iconImage.png";
import classes from "./SharePrivacy.module.css";
import "antd/dist/antd.css";
import { DropDownMenu } from "./DropDownMenu/DropDownMenu";
import ShareForm from "./ShareForm";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { workwiseServices } from "../../WorkW-Api/workWiseApi";
import { useSelector, useDispatch } from "react-redux";
import { slideAction } from "../../../store/slideSlice";
import { slideAPI } from "../../../store/api";
import AvatarComp from "../../Avatar";

export const SharePrivacy = ({ contentToggle, setIsModalVisible, privacy, setPrivacy }) => {

  const dispatch = useDispatch();

  const documentInformation = useSelector((state) => state.slide.documentInformation);
  const isExternalAllow = useSelector((state) => state.slide.isExternalAllow);
  const mileSlidesName = documentInformation.name;
  const isMobile = window.screen.width < 767;

  const { id } = useParams()
  const privacyId = 1
  const payload = { attachmentId: id, name: mileSlidesName, privacyId }

  const callShareDocumentToAnyone = async () => {
    try {
      await workwiseServices.shareDocumentToAnyone(payload);
      message.success("Document is shared as Public");
      setIsModalVisible(false);
      const response = await workwiseServices.getDocumentById(id);
      if (response?.status === 200 && response.data?.data?.rightType !== 0) {
        dispatch(slideAction.setDocumentInformation(response.data.data));
      }
      await slideAPI.updateDocumentPrivacy({ documentId: id, isExternal: true, name: documentInformation?.name });
      dispatch(slideAction.setIsExternalAllow(true));
    } catch (error) {
      console.error("Error sharing document:", error);
      message.error("Failed to share document. Please try again.");
    }
  };

  const handleRemoveAccess = async () => {
    try {
      await slideAPI.updateDocumentPrivacy({
        documentId: id,
        isExternal: false,
        name: documentInformation?.name
      });
      dispatch(slideAction.setIsExternalAllow(false));
      message.success("External access removed successfully!");
      setIsModalVisible(false);
    } catch (error) {
      console.error("Error removig document access:", error);
      const errorMessage = error.response?.data?.message || "Failed to remove access.";
      message.error(errorMessage);
    }
  };

  return (
    <div className={classes.ownerInfo}>
      {
        privacy === 0 &&
        <div className={classes.avatar}>
          <AvatarComp />
        </div>
      }
      <div className={classes.info}>
        <div className={classes.name}>
          {contentToggle ? (
            <h4>Name</h4>
          ) : (
            <DropDownMenu
              menuItems={[{ label: "Restricted", key: 1 }, { label: "Anyone", key: 0 }]}
              placement="bottomLeft"
              type={privacy}
              setType={setPrivacy}
            />
          )}
        </div>
        <div className={classes.email}>
          {privacy === 1 ? (
            <>
              <ShareForm setIsModalVisible={setIsModalVisible} setPrivacy={setPrivacy} />
            </>
          ) : (
            <>
              <p>Anyone with the link can access
              </p>
              <div className={classes.publicShareBtnsContainer}>
                <Button
                  onClick={callShareDocumentToAnyone}
                  className={`${classes.shareBtn}`}
                  size="middle"
                  htmlType="submit"
                  style={{ width: isExternalAllow ? '140px' : 'fit-content' }}
                  disabled={isExternalAllow}
                >
                  Make public
                </Button>
                {isExternalAllow &&
                  <Button
                    size="middle"
                    className={`${classes.removeAccessBtn}`}
                    htmlType="submit"
                    onClick={handleRemoveAccess}
                  >
                    Remove external
                  </Button>
                }
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
